import axios from 'axios'
import router from '../router'

export const apiParams = {
  baseURL:
    window._env_.VUE_APP_USE_API_URL === 'true'
      ? window._env_.VUE_APP_API_URL
      : `${window.location.protocol}//${window.location.host}`,

  timeout: 20000,
  withCredentials: true
}
const api = axios.create(apiParams)

let openReqs = 0

export const initInterceptors = store => {
  api.interceptors.request.use(config => {
    if (openReqs === 0) {
      store.commit('startLoading')
    }
    openReqs++
    return config
  })

  api.interceptors.response.use(
    resp => {
      openReqs--
      if (openReqs === 0) {
        store.commit('stopLoading')
      }
      const message = resp.data.message
      const show = resp.data?.show ? true : false

      if (message && show) {
        store.dispatch('notify', {
          newNotification: { type: 'success', message }
        })
      }
      return resp
    },
    err => {
      openReqs--
      if (openReqs === 0) {
        store.commit('stopLoading')
      }

      const message = err.response?.data?.message ?? 'Hoppá! Hiba történt.'

      if (err.response.status === 401 && message === 'Unauthenticated! Please log in.') {
        console.log('Authentication error.')
        router.push('/session-expired')
      } else {
        if (err.response.status !== 400 && err.response.data && err.response.data.details) {
          // customize notifications from data returned from the API
          store.dispatch('notify', {
            newNotification: { type: 'danger', message }
          })
        }
      }

      throw err
    }
  )
}

export default api
